
import common from '@/utils/common';
import SectionRanking from '@/components/posts/SectionRanking.vue';
import SectionPosts from '@/components/posts/SectionPosts.vue';
import SectionSubs from '@/components/posts/SectionSubs.vue';
import SectionNotices from '@/components/posts/SectionNotices.vue';
import { mapGetters, mapActions } from 'vuex';
export default {
  auth: false,
  mixins: [common],
  components: {
    SectionRanking,
    SectionPosts,
    SectionSubs,
    SectionNotices,
  },
  data() {
    return {
      // menuIndex: 0,
      activeMenuColor: '#C2DC00',
      menuItems: [
        // { title: '랭 킹', inactiveImg: 'menu_ranking_inactive.png', activeImg: 'menu_ranking_active.png', board: 'rankings' },
        {
          title: '커뮤니티',
          inactiveImg: 'menu_comm_inactive.png',
          activeImg: 'menu_comm_active.png',
          board: 'clips',
        },
        // { title: '마을소식', inactiveImg: 'menu_dist_comm_inactive.png', activeImg: 'menu_dist_comm_active.png', board: 'photos' },
        // { title: '구 독', inactiveImg: 'menu_subs_inactive.png', activeImg: 'menu_subs_active.png', board: 'asks' },
        {
          title: '공 지',
          inactiveImg: 'menu_notice_inactive.png',
          activeImg: 'menu_notice_active.png',
          board: 'meetings',
        },
      ],
      rankings: [],
      listItems: {
        postList: [],
        postLinks: {},
        postMeta: {},
      },
      form: {
        board: '',
        page: 0,
        district_id: this.$store.state.district.id,
        word: this.$route.query.word ?? '',
      },
      noticeItems: {
        data: [],
        links: {},
      },
    };
  },
  head: {
    meta: [
      { name: 'google-adsense-account', content: 'ca-pub-9411006336667814' },
    ],
  },
  computed: {
    ...mapGetters(['getPostColors', 'getPostMenuIndex']),
    menuIndex() {
      return this.getPostMenuIndex;
    },
    styleObject() {
      return {
        '--menu-color': this.activeMenuColor,
      };
    },
  },
  watch: {
    menuIndex: {
      handler(index) {
        this.activeMenuColor =
          this.getPostColors[Object.keys(this.getPostColors)[index]];
      },
      immediate: true,
    },
  },
  methods: {
    ...mapActions(['FETCH_POST_MENU_INDEX']),
    selectBoard(board, index) {
      this.form.board = board;
      // this.menuIndex = index;
      this.FETCH_POST_MENU_INDEX(index);
    },
    // 랭킹 데이터 조회
    async getRankings(rankingUrl, count) {
      // 서버 과부화방지용 json 데이터 로드
      // const rankings = await this.$axios.$get('/data/ranking_static_data.json')
      // this.districtRegisterCounts = rankings.districtRegisterCounts;

      // 기존 db 데이터 조회
      const response = await this.$axios.get(`/api/${rankingUrl}/${count}`);
      this.rankings = [...response.data.districtRegisterCounts];
    },
    getNoticeItems() {
      this.form.page = 1;

      this.$axios
        .get('/api/notices', {
          params: this.form,
        })
        .then((response) => {
          this.noticeItems = response.data;
        });
    },
  },
  mounted() {
    // this.selectBoard(this.menuItems[1].board, 1);
    if (this.$store.state.isFlutter && window.flutterSetComponents) {
      window.flutterSetComponents.postMessage('/posts');
    }
    // this.getRankings('total-rankings', 10);
    this.getNoticeItems();
    if (this.$route.query.board) {
      this.FETCH_POST_MENU_INDEX(Number(this.$route.query.board));
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      console.log(from.fullPath, 'beforeRouteEnter');
      if (
        !(
          from.fullPath.includes('posts') ||
          from.fullPath.includes('create') ||
          from.fullPath.includes('notices')
        )
      ) {
        vm.FETCH_POST_MENU_INDEX(0);
      }
    });
  },
};
